<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="time">
                <div class="cont">
                    <div class="cont_a">
                        <div class="bule"></div>
                        <div class="p">资料专区（专辑下载）</div>
                    </div>
                    <div class="cont_b">
                        <div class="cont_text" v-for="(item, index) in list" :key="index">
                            <div class="cont_title" @click="xz(item.url)"><a :href="item.url"></a>{{ item.fileName }}
                            </div>
                            <div class="cont_time">{{ item.createTime }}&nbsp;&nbsp;&nbsp;</div>
                          <el-button type="primary" size="mini"  @click="preview(item.url)">预览</el-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

      <div
        style=" width: 100%; background: #fff; height: 60px; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
        <el-pagination :current-page="currentPage" :page-size="100" :page-sizes="[10, 20, 30, 40]" :total="total"
                       layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>


        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"
import {download, ministries} from "../api";
export default {
    components: {
        top,
        bottom,
        navs
    },
    data() {
        return {
            list: [],
            total: 0, // 总数量
            pageNo: 1, // 当前页数
            pageSize: 9, // 当前显示数量
            currentPage: 1,
        }
    },
    created() {
        // axios({
        //     method: "GET",
        //     url: "https://www.jnccljh.com/api/resources/download"
        // }).then(res => {
        //     console.log(res)
        //     this.list = res.data.data.records
        // })

      download(this.pageNo, this.pageSize).then(res => {
        console.log(res)
        this.list = res.data.data.records
        this.total = res.data.data.total
      })
    },
    methods: {


      /**
       * 页码改变触发后
       * **/
      handleCurrentChange(val) {
        console.log(val, '页码改变触发后')
        this.pageNo = val
        download(this.pageNo, this.pageSize).then(res => {
          console.log(res)
          this.list = res.data.data.records
          this.total = res.data.data.total
        })
      },
      /**
       * 每条多少页改变后
       * **/
      handleSizeChange(val) {
        console.log(val, '页数改变后')
        this.pageSize = val
        download(this.pageNo, this.pageSize).then(res => {
          console.log(res)
          this.list = res.data.data.records
          this.total = res.data.data.total
        })


      },

      preview(item) {
          window.open(item);
      },

        xz(item) {
            //请求并且传递音乐名称
            fetch(item, {
                method: 'get',
                responseType: 'blob'
            }).then(res => {
                return res.blob();
            }).then(blob => {
                const bl = new Blob([blob], { type: "audio/pdf" });
                const fileName = Date.parse(new Date()) + ".pdf";
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(bl);
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })

        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}

.content {
    width: 100%;
    /* height: 480px; */
    /* height: 1330px; */
    background-image: url(../image/back.png);
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}

.time {
    width: 70%;
    margin: 0 auto;
    /* height: 1330px; */
    /* background-color: #F7F7F7; */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bule {
    width: 5px;
    height: 16px;
    background: #1463FF;
}

.p {
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #333333;
    line-height: 17px;
    font-style: normal;
}

.cont {
    width: 100%;
    margin: 0 auto;

}

.cont_a {
    height: 74px;
    display: flex;
    align-items: center;
}

.cont_b {
    padding: 20px;
    background-color: #FFFFFF;
    margin-bottom: 20px;
}

.cont_text {
    height: 50px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.cont_text:hover {
    height: 50px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1463FF;
}

.cont_title {
    width: 146px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.cont_time {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/zlxz.vue